import { SEO_DESCRIPTION_COUNSELLINGS, SEO_TITLE_COUNSELLINGS } from 'mk/autogenerated/translations/CounsellingsHomePage.c1e003b1ec9e906a812fa8798b320a37'
import { analyticsStoreEvent } from 'mk2/actions';
import CounsellingsHome from 'mk2/apps/counsellings/containers/CounsellingsHome/CounsellingsHome';
import { counsellingsHomeLoad } from 'mk2/apps/counsellings/containers/CounsellingsHome/CounsellingsHome.actions';
import counsellingsHomePageReducer, {
    CounsellingsHomePageState,
    TopicStats,
} from 'mk2/apps/counsellings/containers/CounsellingsHome/CounsellingsHome.reducers';
import saga from 'mk2/apps/counsellings/containers/CounsellingsHome/CounsellingsHome.sagas';
import {
    getCounsellingsHomeComplaintsStatisticsPerTopic,
    getCounsellingsHomePageState,
} from 'mk2/apps/counsellings/containers/CounsellingsHome/CounsellingsHome.selectors';
import { counsellingsHomeUrl } from 'mk2/apps/counsellings/urls';
import { getForumComplaintsStatistics, getForumNotificationsOn } from 'mk2/apps/forum/reducers';
import {
    ComplaintsCountPerTopic,
    ComplaintsStatisticsPerPost,
    CounsellingEntity,
    CounsellingSchema,
    PostEntity,
    PostSchema,
    TopicEntity,
    TopicSchema,
} from 'mk2/apps/forum/schemas';
import { breadcrumbsCounsellings } from 'mk2/apps/forum/structuredData';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page, { BrandingProps, HalfpageProps } from 'mk2/pages/Page';
import {
    AppState,
    getRequestBaseUrl,
    getRequestDeviceMobile,
    getRequestPermissions,
    getRequestUser,
} from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { UserEntity } from 'mk2/schemas';
import { getDenormalizedEntities } from 'mk2/selectors';
import { Store } from 'mk2/store/configureStore';
import { parse } from 'query-string';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

interface OwnProps {}

interface StateProps {
    after: number;
    posts: PostEntity[];
    hasNext: number;
    hasPrevious: number;
    mobile: boolean;
    notificationsOn: number[];
    requestUser: UserEntity;
    loadingState: LoadingState;
    errorMessage: string;
    baseUrl: string;
    permissions: string[];
    complaintsStatistics: ComplaintsStatisticsPerPost;
    complaintsStatisticsPerTopic: ComplaintsCountPerTopic;
    counsellings: CounsellingEntity[];
    topicStats: TopicStats;
    lastVisitCounts: TopicStats;
    followingTopics: TopicEntity[];
}

interface DispatchProps {
    onLoad(after?: number);
    onStoreEvent(name: string, props: any);
}

type RouteProps = RouteComponentProps<{}>;
export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class CounsellingsHomePage extends Page<OwnProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const parsed = parse(ownProps.location.search);
            const after = parsed.after;

            const substate: CounsellingsHomePageState = getCounsellingsHomePageState(state);

            return {
                after,
                posts: getDenormalizedEntities<PostEntity>(state, PostSchema, substate.ids),
                hasNext: substate.hasNext,
                hasPrevious: substate.hasPrevious,
                loadingState: substate.loadingState,
                errorMessage: substate.errorMessage,
                notificationsOn: getForumNotificationsOn(state),
                mobile: getRequestDeviceMobile(state),
                requestUser: getRequestUser(state),
                baseUrl: getRequestBaseUrl(state),
                permissions: getRequestPermissions(state),
                complaintsStatistics: getForumComplaintsStatistics(state),
                complaintsStatisticsPerTopic: getCounsellingsHomeComplaintsStatisticsPerTopic(state),
                counsellings: getDenormalizedEntities<CounsellingEntity>(state, CounsellingSchema, substate.counsellingIds),
                followingTopics: getDenormalizedEntities<TopicEntity>(state, TopicSchema, substate.followingTopicIds),
                topicStats: substate.topicStats,
                lastVisitCounts: substate.lastVisitCounts,
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onLoad: counsellingsHomeLoad,
            onStoreEvent: analyticsStoreEvent,
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_COUNSELLINGS;
    }

    public getMetaDescription(props: Props): string {
        return SEO_DESCRIPTION_COUNSELLINGS;
    }

    public getStructuredData(props: Props): object[] {
        return [breadcrumbsCounsellings(props.baseUrl)];
    }

    public getCanonicalUrl(baseUrl: string, props: Props): string {
        return baseUrl + counsellingsHomeUrl;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <span>
                <CounsellingsHome {...props} />
            </span>
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    public getHalfpageProps(props: Props): HalfpageProps {
        return {
            zone: 'Forum Category - Halfpage Sticky (Desktop)',
        };
    }

    public getBrandingProps(props: Props): BrandingProps {
        return {
            zone: 'Forum - Branding',
        };
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer('containers.counsellings.home', counsellingsHomePageReducer);
        store.injectSaga('containers.counsellings.home', saga);
    }

}
